export interface ISnackbarNotification {
    key: number;
    message: string;
    type: 'default' | 'error' | 'success' | 'warning' | 'info';
    persist: boolean;
}

class SnackBarType {
    static ERROR = 'error';
    static SUCCESS = 'success';
    static WARNING = 'warning';
    static INFO = 'info';
    static DEFAULT = 'info';
}

export default SnackBarType;
